var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _path7, _g4, _g5, _path8, _path9, _path10, _g6, _path11, _path12, _path13, _g7, _path14, _path15, _path16, _g8, _g9, _path17, _path18, _path19, _path20, _path21, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttackbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 65,
    viewBox: "0 0 104 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0655 49.5938H45.1201V59.9792H58.0655V49.5938Z",
    fill: "url(#paint0_linear_1137_1919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1378 8.5H15.8976C15.2001 8.5 14.6348 9.06215 14.6348 9.7556V51.8906C14.6348 52.584 15.2001 53.1462 15.8976 53.1462H88.1378C88.8352 53.1462 89.4006 52.584 89.4006 51.8906V9.7556C89.4006 9.06215 88.8352 8.5 88.1378 8.5Z",
    fill: "url(#paint1_linear_1137_1919)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4006 9.7556V48.3699H14.6348V9.7556C14.6348 9.06155 15.1995 8.5 15.8976 8.5H88.1441C88.8422 8.5 89.4069 9.06155 89.4069 9.7556H89.4006Z",
    fill: "#1C2538"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4828 61.5004H43.0637C42.5687 61.5004 42.1689 61.1029 42.1689 60.6108V59.6328H61.3839V60.6108C61.3839 61.1029 60.9841 61.5004 60.4892 61.5004H60.4828Z",
    fill: "url(#paint2_linear_1137_1919)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1642 51.5621C52.8546 51.5621 53.4143 51.0056 53.4143 50.3191C53.4143 49.6327 52.8546 49.0762 52.1642 49.0762C51.4738 49.0762 50.9141 49.6327 50.9141 50.3191C50.9141 51.0056 51.4738 51.5621 52.1642 51.5621Z",
    fill: "#1C2538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3506 45.1713V11.3964C17.3506 10.9421 17.7186 10.5762 18.1755 10.5762H85.8595C86.3164 10.5762 86.6844 10.9421 86.6844 11.3964V45.1713C86.6844 45.7896 86.1577 46.2944 85.5168 46.2944H18.5182C17.8709 46.2944 17.3506 45.7896 17.3506 45.1713Z",
    fill: "url(#paint3_linear_1137_1919)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6242 29.1377L20.3778 30.3554L19.9273 30.8791L19.8829 31.6804L18.2076 31.3082L16.7227 30.3807V31.2577L17.4588 31.9265L20.5809 32.5322L20.9807 30.8097L23.1953 29.327",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6815 26.7046L22.4087 25.0956L19.1787 24.5404L19.02 22.8242L18.9883 24.8685L21.9454 25.266V26.7803",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6634 28.1044L19.4387 25.751L16.7227 26.5334V27.4482L19.0833 27.1264L20.5174 28.9941",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7535 27.9895L22.3955 25.4026L19.5779 24.9231L19.4383 23.4277L19.413 25.207L21.9449 25.554V26.9232L23.1125 28.1977L22.5668 28.9549L20.5742 30.0338L20.1808 30.4944L20.1427 31.2074L18.6578 30.873L17.3506 30.059V30.8225L17.9915 31.4093L20.7392 31.9393L21.0882 30.425L23.0364 29.1252",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8046 20.1159L26.3429 19.4156L25.6385 18.324L26.8379 16.1031L25.4545 14.5825C25.4545 13.4783 24.9278 10.5759 24.9278 10.5759L21.5265 10.7778L20.9236 10.374H18.6455L19.7687 12.8663H21.1521L20.7777 14.1661L21.9389 15.245L24.4138 14.9863L25.721 16.1788L24.2678 18.4439L24.7945 19.0433L23.6967 19.4156L23.8173 20.1159H23.8046ZM22.0722 14.6645L21.5645 13.838L22.0722 12.4057L19.9464 12.0839L19.7306 11.2195L21.4948 11.6233H23.9442L24.4138 14.4121L22.0722 14.6645Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8235 14.9434L21.1075 16.9687V18.8616L19.7305 20.7103L20.8981 18.8363V16.8551L23.4808 14.9434H23.8235Z",
    fill: "#EB0037"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.809 28.0539L19.7366 25.9844L17.3506 26.6721V27.4734L19.4256 27.1958L20.6821 28.8363",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8046 20.1159L26.3429 19.4156L25.6385 18.324L26.8379 16.1031L25.4545 14.5825C25.4545 13.4783 24.9278 10.5759 24.9278 10.5759L21.5265 10.7778L20.9236 10.374H18.6455L19.7687 12.8663H21.1521L20.7777 14.1661L21.9389 15.245L24.4138 14.9863L25.721 16.1788L24.2678 18.4439L24.7945 19.0433L23.6967 19.4156L23.8173 20.1159H23.8046ZM22.0722 14.6645L21.5645 13.838L22.0722 12.4057L19.9464 12.0839L19.7306 11.2195L21.4948 11.6233H23.9442L24.4138 14.4121L22.0722 14.6645Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8235 14.9414L21.1075 16.9668V18.8596L19.7305 20.7083L20.8981 18.8344V16.8532L23.4808 14.9414H23.8235Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 42.3006V44.5342L15.7832 45.7898L17.56 44.2566V46.2946H19.2416L19.6604 46.711L21.0628 46.3829C21.0628 46.3829 20.0666 47.3041 19.9079 47.5502C19.7493 47.7962 18.7022 48.7868 18.7022 48.7868H16.6906L14.3554 50.7617L16.7604 48.9319L19.0512 49.1591C19.0512 49.1591 21.0184 46.9886 21.6213 46.8119L22.0909 45.7267L20.2506 46.0043L19.5018 45.3229L18.2961 45.55L17.7567 42.8622L16.405 44.2503L17.0587 42.9379L18.1501 42.288C18.1501 42.288 19.0259 42.7739 19.1401 42.7739C19.2543 42.7739 20.8344 42.5783 20.8344 42.5783L23.1443 43.5625L25.2574 42.1366L27.0977 42.3006L29.1791 43.2408L31.7681 42.1429L32.7073 43.8275L33.3102 43.9601L33.4244 43.6067L32.1552 40.8242L29.3758 42.1997L27.7957 41.1018L24.9464 41.1334L23.1252 42.2312L20.4409 41.6318L18.9307 41.7265L17.744 41.3542L16.4431 42.0356L15.726 43.6824L14 42.2943L14.0063 42.3006Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4253 41.297V43.7009L16.2021 44.9565L17.9789 43.4233V45.4612H19.6605L20.0794 45.8777L21.4818 45.5496C21.4818 45.5496 20.4855 46.4708 20.3269 46.7168C20.1682 46.9629 19.1212 47.9535 19.1212 47.9535H17.1793L14.7806 49.9789L17.2555 48.0986L19.6098 48.3321C19.6098 48.3321 21.6341 46.1048 22.2496 45.9218L22.7319 44.8114L20.8409 45.0953L20.073 44.3949L18.8356 44.6284L18.2835 41.8711L16.8938 43.2971L17.5601 41.9532L18.6833 41.2906C18.6833 41.2906 19.5844 41.7891 19.6986 41.7891C19.8128 41.7891 21.4374 41.5872 21.4374 41.5872L23.8107 42.603L25.9809 41.1392L27.872 41.3033L30.0105 42.2686L32.6694 41.1392L33.6339 42.868L34.2495 43.0005L34.3637 42.6346L33.0628 39.7764L30.2072 41.1897L28.589 40.0603L25.6636 40.0918L23.7916 41.2212L21.0376 40.6092L19.4829 40.7102L18.2645 40.3253L16.9255 41.0256L16.1894 42.7229L14.4189 41.297H14.4253Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6201 41.7269L25.3525 38.8182H27.5862L29.9532 37.6257L31.4508 36.3701L29.9024 37.5752L27.5354 39.0264L25.2129 39.0012L23.5947 41.7269H23.6201Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4525 37.8078L29.1542 37.0191L29.5477 36.3692L29.2621 34.5205L29.351 36.3692L28.9385 37.0191L29.3129 37.8835L29.4525 37.8078Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8194 16.7596V18.9932L88.0426 20.2488L86.2658 18.7156V20.7536H84.5841L84.1653 21.17L82.7629 20.8419C82.7629 20.8419 83.7592 21.7631 83.9178 22.0092C84.0765 22.2552 85.1235 23.2458 85.1235 23.2458H87.1352L89.4704 25.2207L87.0653 23.3909L84.7745 23.6181C84.7745 23.6181 82.8073 21.4476 82.2045 21.2709L81.7349 20.1857L83.5752 20.4633L84.324 19.7819L85.5297 20.009L86.0691 17.3212L87.4207 18.7093L86.7671 17.3969L85.6756 16.747C85.6756 16.747 84.7999 17.2329 84.6857 17.2329C84.5715 17.2329 82.9914 17.0373 82.9914 17.0373L80.6815 18.0215L78.5684 16.5956L76.7281 16.7596L74.6467 17.6998L72.0576 16.6019L71.1184 18.2865L70.5156 18.419L70.4014 18.0657L71.6705 15.2832L74.45 16.6587L76.0301 15.5608L78.8793 15.5924L80.7005 16.6902L83.3848 16.0908L84.8951 16.1855L86.0818 15.8132L87.3826 16.4946L88.0997 18.1414L89.8258 16.7533L89.8194 16.7596Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4003 15.7569V18.1609L87.6235 19.4164L85.8467 17.8832V19.9212H84.1651L83.7462 20.3376L82.3438 20.0095C82.3438 20.0095 83.3401 20.9307 83.4988 21.1768C83.6574 21.4229 84.7044 22.4135 84.7044 22.4135H86.6462L89.0449 24.4388L86.5701 22.5586L84.2158 22.792C84.2158 22.792 82.1915 20.5648 81.576 20.3818L81.0937 19.2713L82.9847 19.5553L83.7526 18.8549L84.99 19.0884L85.5421 16.3311L86.9318 17.757L86.2655 16.4131L85.1423 15.7506C85.1423 15.7506 84.2412 16.2491 84.127 16.2491C84.0128 16.2491 82.3882 16.0472 82.3882 16.0472L80.0149 17.063L77.8447 15.5992L75.9536 15.7632L73.8151 16.7286L71.1562 15.5992L70.1917 17.328L69.5761 17.4605L69.4619 17.0945L70.7628 14.2363L73.6184 15.6497L75.2366 14.5203L78.162 14.5518L80.034 15.6812L82.788 15.0692L84.3427 15.1701L85.5611 14.7853L86.9001 15.4856L87.6362 17.1829L89.4067 15.7569H89.4003Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2125 16.1849L78.4801 13.2762H76.2464L73.8731 12.0837L72.3818 10.8281L73.9302 12.0332L76.2908 13.4844L78.6197 13.4592L80.2315 16.1849H80.2125Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.373 12.2658L74.6713 11.4771L74.2842 10.8272L74.5634 8.97852L74.4809 10.8272L74.8934 11.4771L74.5126 12.3415L74.373 12.2658Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2125 16.1859L78.4801 13.2772H76.2464L73.8731 12.0847L72.3818 10.8291L73.9302 12.0342L76.2908 13.4854L78.6197 13.4602L80.2315 16.1859H80.2125Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.373 12.2667L74.6713 11.4781L74.2842 10.8282L74.5634 8.97949L74.4809 10.8282L74.8934 11.4781L74.5126 12.3425L74.373 12.2667Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9448 25.461L24.077 26.0793L24.4768 27.5368L25.7015 28.8555L26.7676 29.6064L25.7269 28.8114L24.5149 27.4927L24.1341 26.0289L21.9258 25.3916L21.9448 25.461Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.498 28.5647L25.9422 28.2303L26.4245 28.3754L27.5477 27.877L26.3928 28.2492L25.9041 28.0915L25.4219 28.4827L25.498 28.5647Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.353 17.0427L27.0029 15.56L28.4561 15.989L30.2266 15.6483L31.4323 15.1436L30.2012 15.6041L28.4371 15.9386L26.9839 15.4906L25.2832 17.0238L25.353 17.0427Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8647 15.6675L29.8203 15.1185L30.1947 14.7841L30.3597 13.5664L30.0678 14.7463L29.6807 15.0744L29.7632 15.6864L29.8647 15.6675Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2949 41.1888L37.6952 37.8826L39.6877 33.2956L42.6639 32.9927L46.1731 29.8317V22.418C46.1731 22.418 46.941 30.6519 46.7315 31.2765L49.657 30.0336C49.657 30.0336 47.1504 32.5258 46.3127 32.5258C45.4751 32.5258 44.6438 32.3176 44.6438 32.3176C44.6438 32.3176 43.1843 33.7688 42.9749 33.7688C42.7655 33.7688 40.9823 34.1284 40.9823 34.1284L38.5963 39.8575L37.0923 39.0688L33.5197 41.6872L32.3013 41.1888H32.2949Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1137_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.876 41.8138L37.2762 38.5076L39.2688 33.9206L42.245 33.6177L45.7542 30.4567V23.043C45.7542 23.043 46.522 31.2769 46.3126 31.9015L49.238 30.6586C49.238 30.6586 46.7314 33.1508 45.8938 33.1508C45.0561 33.1508 44.2249 32.9426 44.2249 32.9426C44.2249 32.9426 42.7653 34.3938 42.5559 34.3938C42.3465 34.3938 40.5633 34.7534 40.5633 34.7534L38.1773 40.4825L36.6734 39.6938L33.1007 42.3123L31.8823 41.8138H31.876Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1137_1919",
    x: 8.72266,
    y: 21.1377,
    width: 22.4727,
    height: 19.3945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1137_1919",
    x: 10.9883,
    y: 14.8242,
    width: 19.6934,
    height: 19.9561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1137_1919",
    x: 8.72266,
    y: 17.751,
    width: 19.9404,
    height: 19.2432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1137_1919",
    x: 10.6455,
    y: 2.37402,
    width: 24.1924,
    height: 25.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1137_1919",
    x: 11.7305,
    y: 6.94336,
    width: 20.0928,
    height: 21.7666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1137_1919",
    x: 0,
    y: 26.8242,
    width: 47.4248,
    height: 37.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1137_1919",
    x: 56.4014,
    y: 1.2832,
    width: 47.4248,
    height: 37.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1137_1919",
    x: 64.3818,
    y: 2.8291,
    width: 23.8496,
    height: 21.3564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1137_1919",
    x: 66.2842,
    y: 0.979492,
    width: 16.6094,
    height: 19.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1137_1919",
    x: 23.876,
    y: 15.043,
    width: 33.3623,
    height: 35.2695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1137_1919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_1919",
    x1: 51.5928,
    y1: 82.7503,
    x2: 51.5928,
    y2: 42.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1137_1919",
    x1: 19.6225,
    y1: 7.54726,
    x2: 168.256,
    y2: 115.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1137_1919",
    x1: 51.8589,
    y1: 54.8565,
    x2: 51.7209,
    y2: 64.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1137_1919",
    x1: 52.0175,
    y1: 56.7934,
    x2: 52.0175,
    y2: -18.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EB0037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7A1123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackbox);
export default __webpack_public_path__ + "static/media/attackbox.9cb40a97119043ff77b3c9ec46f664b2.svg";
export { ForwardRef as ReactComponent };